import { initializeApp } from 'firebase/app'
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut as firebaseSignOut,
} from 'firebase/auth'

// Mismo patrón que connect-auth-api / KAI Academy: Google SSO + allowlist @connect.inc.
// Las credenciales van en variables VITE_FIREBASE_* — ver .env.example.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const ALLOWED_DOMAIN = import.meta.env.VITE_ALLOWED_EMAIL_DOMAIN ?? 'connect.inc'

export const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)

const googleProvider = new GoogleAuthProvider()
googleProvider.setCustomParameters({ hd: ALLOWED_DOMAIN }) // hint de Google Workspace, no es la validación real

export async function signInWithGoogle() {
  const result = await signInWithPopup(auth, googleProvider)
  const email = result.user.email ?? ''
  if (!email.endsWith(`@${ALLOWED_DOMAIN}`)) {
    await firebaseSignOut(auth)
    throw new Error(`Solo cuentas @${ALLOWED_DOMAIN} pueden acceder a este panel.`)
  }
  return result.user
}

export async function signOut() {
  await firebaseSignOut(auth)
}
